/* jshint esversion: 6 */

import Vue from 'vue';
import App from './App';

Vue.config.productionTip = false;

new Vue({
    el         : '#app',
    template   : '<App/>',
    components : { App }
});



// WEBPACK FOOTER //
// ./src/main.js